import Button from "@mui/material/Button";
import { removeScopes } from "api/layer";
import Modal from "components/modal/modal";
import { AppAction, AppContext } from "helpers/context";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./delete-modal.module.scss";

interface Props {
	data: any;
	initData: () => void;
	onClose: () => void;
}

const DeleteModal: React.FC<Props> = ({ data, initData, onClose }) => {
	const [t] = useTranslation();
	const [context, dispatch] = useContext(AppContext);

	const confirmDelete = (): void => {
		removeScopes(data.id)
			.then((resp: any) => {
				if (!resp || resp.code !== 200) {
					dispatch({
						type: AppAction.addSnackBarParams,
						payload: {
							title: "deleteEndPointScope",
							titleIconColor: "yellow",
							titleIcon: "warning",
							resMessage: resp.message,
						},
					});
					return;
				}
				dispatch({
					type: AppAction.addSnackBarParams,
					payload: {
						title: "deleteEndPointScope",
						message: "deleteEndPointScopeSuccess",
					},
				});
			})
			.catch((error: any) => {
				console.error(error);
				dispatch({
					type: AppAction.addSnackBarParams,
					payload: {
						title: "deleteEndPointScope",
						titleIconColor: "red",
						titleIcon: "error",
						message: "deleteEndPointScopeError",
					},
				});
			})
			.finally(() => {
				initData();
				onClose();
			});
	};

	return (
		<Modal
			header={t("userSystem.deleteEndPointScope.title")}
			opened={!!data.id}
			onClose={onClose}
		>
			<div className={styles.info}>
				<div className={styles.text}>{`${t("userSystem.deleteEndPointScope.prefix")}${data.scopeName}${t("userSystem.deleteEndPointScope.suffix")}`}</div>

				<div className={styles.button}>
					<Button
						variant="text"
						color="success"
						onClick={onClose}
						style={{ outline: "none" }}
					>
						{t("buttons.cancel")}
					</Button>
					&nbsp;&nbsp;
					<Button
						variant="contained"
						color="error"
						onClick={confirmDelete}
					>
						{t("buttons.delete")}
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default DeleteModal;
